import React from "react";
import PropTypes from "prop-types";
import {
  AButton,
  AModal,
  APanel,
  APanelBody,
  APanelFooter,
  APanelHeader,
  APanelTitle
} from "@cisco-sbg-ui/magna-react";
import {useTranslation} from "react-i18next";

const DeleteModal = ({
  title,
  open,
  setOpen,
  onDelete,
  disabled,
  classNames,
  children
}) => {
  const {t} = useTranslation();

  const handleDelete = () => {
    onDelete();
    setOpen(false);
  };

  return (
    <AModal
      medium
      aria-labelledby="modalTitle"
      data-testid={"DeleteModal-Dialog"}
      className={`${classNames}`}
      onClickOutside={() => setOpen(false)}
      isOpen={open}>
      <APanel type="dialog">
        <APanelHeader>
          <APanelTitle id="modalTitle">{title}</APanelTitle>
        </APanelHeader>
        <APanelBody className="pt-0">{children}</APanelBody>
        <APanelFooter id="delete-modal-btns">
          <AButton
            data-testid={"DeleteModal-Button-cancel"}
            className="mr-2"
            medium
            tertiary
            onClick={() => setOpen(false)}>
            {t("misc.cancel")}
          </AButton>
          <AButton
            destructive
            data-testid={"DeleteModal-Button-delete"}
            id="confirm-delete-btn"
            medium
            onClick={() => handleDelete()}
            disabled={disabled}>
            {t("misc.delete")}
          </AButton>
        </APanelFooter>
      </APanel>
    </AModal>
  );
};

DeleteModal.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  onDelete: PropTypes.func,
  disabled: PropTypes.bool,
  classNames: PropTypes.string
};

export default DeleteModal;
